export default __webpack_public_path__ + "static/media/plus-icon.c46bdcd9.svg";